<app-navbar></app-navbar>

<section class="blog-details-area py-5">
    <div class="container">
        <div class="row g-4">
            <div class="col-lg-8 col-md-12">
                <div class="blog-details-desc">
                    <h2 class="premium-heading-title mb-4">
                        Teacher Information
                    </h2>

                    <ng-container *ngIf="all_employee_data != null">
                        <div class="container mt-4">
                            <div class="row g-4 justify-content-center">
                                <div class="col-lg-12 col-md-12 col-sm-12" *ngFor="let item of paginated_teachers_info">
                                    <!-- Premium Horizontal Teacher Card -->
                                    <div class="teacher-card">
                                        <div class="teacher-image-wrapper">
                                            <img [src]="item.ImageLink" alt="teacher" class="teacher-image" />
                                        </div>
                                        <div class="teacher-content">
                                            <h4 class="teacher-name">{{ item.EmployeeName }}</h4>
                                            <div class="teacher-details">
                                                <strong>Role:</strong> <span class="teacher-role">{{ item.Designation }}</span> <br>
                                                <strong>Employee ID:</strong> {{ item.EmployeeId }} <br>
                                                <strong>Joined:</strong> {{ item.JoiningDate | date : "MMMM d, yyyy" }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="d-flex justify-content-center mt-5" *ngIf="totalPages.length > 1">
                                <button class="btn btn-outline-dark mx-1 pagination-btn" (click)="onPageChange(pageIndex - 1)" [disabled]="pageIndex === 0">Previous</button>
                                <button class="btn mx-1 pagination-btn" *ngFor="let page of totalPages; let i = index" (click)="onPageChange(i)" [ngStyle]="{'background-color': pageIndex === i ? '#0d173d' : 'transparent', 'color': pageIndex === i ? '#00f2ff' : '#0d173d', 'border': '1px solid #0d173d'}">{{ page }}</button>
                                <button class="btn btn-outline-dark mx-1 pagination-btn" (click)="onPageChange(pageIndex + 1)" [disabled]="pageIndex + 1 >= totalPages.length">Next</button>
                            </div>

                            <div *ngIf="all_teachers_info == null">
                                <div class="text-center py-5">
                                    <div class="empty-state-card">
                                        <i class="fa-solid fa-users-slash empty-state-icon"></i>
                                        <h3 class="empty-state-title">No Data Found</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <app-aside></app-aside>
            </div>
        </div>
    </div>
</section>